<template>
  <v-container fluid style = 'padding:0;'>
    <div class = 'status-wrapper'>

      <!-- Alerts -->
      <v-snackbar v-model="showErrorAlert" color="error" dismissible location="top">
        {{ errorMessage }}
      </v-snackbar>

      
      <!-- Already answered + accepted -->
      <div v-if="isLoaded&&vacant_request&&vacant_request_jane_patient.current_status=='accepted'" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon--outline</v-icon>
        </div>

        <div class = 'explain-message'>
          Thanks, our team will be in touch with you shortly to confirm your appointment.
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>
          
        </div>

      </div>

      <!-- Already answered + rejected -->
      <div v-else-if="isLoaded&&vacant_request&&vacant_request_jane_patient.current_status=='rejected'" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>

        <div class = 'explain-message'>
          Thanks for letting us know.
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>
          
        </div>
      </div>       


      

      <!-- Pending not answered + Reject Confirm mode -->
      <div v-else-if="isLoaded&&vacant_request&&vacant_request.current_status=='pending'&&isRejectConfirmationMode" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          Oh no!
        </div>
        <div class = 'explain-message'>
          Uh oh Sorry none of those options work for you, we'll get back to you ASAP with some more options.
        </div>

        <div class = 'decline-reason-wrapper'>
          <v-textarea v-model="rejectReason" placeholder="Please let us know some dates and times that work for you." rows="3"
            variant="outlined"
            hide-details
          ></v-textarea>
        </div>            
        <div class = 'button-wrapper'>
          <v-btn @click="isRejectConfirmationMode=false" :disabled="updateUnderway" variant = 'outlined'>Back</v-btn>
          <v-btn @click="setRejected()" :disabled="updateUnderway" variant = 'tonal' class = 'decline-confirm-button'>Confirm</v-btn>
        </div>
        
      </div>



      <!-- Pending not answered + Accept Confirm mode -->
      <div v-else-if="isLoaded&&vacant_request&&vacant_request.current_status=='pending'&&!isThankYouMode&&!isRejectConfirmationMode&&isAcceptConfirmationMode" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>
        <div class = 'explain-message'>
          Are you sure you want to accept this request? 
        </div>        
        <div class = 'confirm-details'>
          <div>
            <div>
              <v-icon>mdi-account</v-icon>                
            </div>
            <div>
              <p>{{ vacant_request.practitioner_label }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-heart</v-icon>                
            </div>
            <div>
              <p>{{ vacant_request_treatments_indexed[selected_treatment_id].display_name }} ({{ vacant_request.treatment_category_display_name }})</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-calendar</v-icon>                
            </div>
            <div>
              <p>{{ selected_schedule_start_date_local_date_nice }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-clock</v-icon>                
            </div>
            <div>
              <p>{{ formatAllowedHourAndMinute({ hour: selected_hour, minute: selected_minute }) }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-currency-usd</v-icon>
            </div>
            <div>
              <p>{{ vacant_request_treatments_indexed[selected_treatment_id].price }} {{ vacant_request_treatments_indexed[selected_treatment_id].hst_applies ? ' plus tax' : '' }}</p>
            </div>
          </div>
        </div>  



        <div class = 'button-wrapper'>
          <v-btn @click="isAcceptConfirmationMode=false" :disabled="updateUnderway" variant = 'outlined'>Back</v-btn>
          <v-btn @click="setAccepted()" :disabled="updateUnderway" variant = 'tonal' class = 'accept-confirm-button'>Confirm</v-btn>
        </div>
      </div>

      <!-- Pending not answered -->
      <div v-else-if="isLoaded&&vacant_request&&vacant_request.current_status=='pending'&&!isThankYouMode&&!isRejectConfirmationMode&&!isAcceptConfirmationMode" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>
        <div class = 'explain-title'>
          We're glad we can help
        </div>

        <div class = 'confirm-details'>
          <div>
            <div>
              <v-icon>mdi-account</v-icon>                
            </div>
            <div>
              <p>{{ vacant_request.practitioner_label }}</p>
            </div>
          </div>
          <div>
            <div>
              <v-icon>mdi-heart</v-icon>                
            </div>
            <div>
              <p v-if="vacant_request.treatments.length <= 1">{{ vacant_request_treatments_indexed[selected_treatment_id].display_name }} ({{ vacant_request.treatment_category_display_name }})</p>
              <p v-if="vacant_request.treatments.length > 1">{{ vacant_request.treatment_category_display_name }}</p>
            </div>
          </div>
          <div v-if="vacant_request.treatments.length > 1">
            <div>
              <v-icon>mdi-calendar-clock</v-icon>                
            </div>
            <div style="display: flex; flex-direction: column;">
              <p v-for="dateTimeRange in availableDateTimeRanges" :key="dateTimeRange" style="margin: 0; margin-bottom: 4px;">
                {{ dateTimeRange }}
              </p>
            </div>
          </div>
        </div>  
        <div class = 'explain-message' v-if="vacant_request.treatments.length > 1">
          Please select treatment.
        </div>

        <div class = 'treatment-list' v-if="vacant_request.treatments.length > 1">

          <v-radio-group v-model="selected_treatment_id" hide-details>
            <div v-for = "treatment in vacant_request.treatments" :key="treatment.treatment_id">            
              <div>
                <v-radio hide-details :label="treatment.display_name + (treatment.show_duration ? ' - ' + treatment.duration_minutes + ' min' : '')" :value="treatment.treatment_id"></v-radio>
              </div>
              <div style = 'margin-left:40px'>
                ${{ treatment.price }} {{ treatment.hst_applies ? '+ Tax' : '' }}
              </div>
            </div>              
          </v-radio-group>

        </div>

        <div class = 'explain-message' v-if="selected_treatment_id">
          Please select a time below.
        </div>

        <div class="option-selection-times" ref="optionTimes" v-if="selected_treatment_id">

          <div v-for="schedule_entry in vacant_request_treatment_schedule_entries_indexed[selected_treatment_id].schedule_entries" :key="schedule_entry.schedule_start_date">
            <div class = 'option-date-title'>{{ schedule_entry.schedule_start_date_local_date_nice }}</div>

            <v-btn
              v-for="allowed_hours_and_minute in schedule_entry.allowed_hours_and_minutes"
              :key="allowed_hours_and_minute"
              :class="{ 'active': schedule_entry.schedule_start_date_local_date_nice === selected_schedule_start_date_local_date_nice && allowed_hours_and_minute.hour == selected_hour && allowed_hours_and_minute.minute == selected_minute }"
              @click="toggleSelectedOption(schedule_entry, allowed_hours_and_minute)"
              variant="outlined"
            >
              {{ formatAllowedHourAndMinute(allowed_hours_and_minute) }}
            </v-btn>
            <v-icon
              v-if="isChevronRightVisible"
              icon="mdi-chevron-right"
              color="grey"
              class = "option-selection-times-chevron-right"
            >
            mdi-chevron-right
            </v-icon>
          </div>
        </div>

        <div class = 'button-wrapper'>
          <v-btn @click="confirmRejected()" :disabled="updateUnderway" variant="outlined" class = 'decline-button small'>Send more options</v-btn>
          <v-btn @click="setConfirm()" :disabled="updateUnderway" variant="tonal">Accept</v-btn>
        </div>

      </div>        

      

      <!-- Pending + Thank You + Accepted -->
      <div v-else-if="isLoaded&&vacant_request&&vacant_request.current_status=='pending'&&isThankYouMode&&thankYouType=='accept'" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>

        <div class = 'explain-message'>
          Thanks, our team will be in touch with you shortly to confirm your appointment.
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>
          
        </div>
      </div>        

      <!-- Pending + Thank You + Rejected -->
      <div v-else-if="isLoaded&&vacant_request&&vacant_request.current_status=='pending'&&isThankYouMode&&thankYouType=='reject'" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-happy-outline</v-icon>
        </div>

        <div class = 'explain-message'>
          Thanks for letting us know.
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>
          
        </div>
      </div>        

      <!-- Not Available for Changes -->
      <div v-else-if="isLoaded&&vacant_request&&vacant_request.current_status!='pending'" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>

        <div class = 'explain-message'>
          Uh oh, it looks like someone grabbed that spot before you.  Please email us or text us to let us know some other times that work for you.
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>
          
        </div>
      </div>

      <!-- Not Found -->
      <div v-else-if="isLoaded&&!vacant_request" class = 'content-item'>

        <div class = 'explain-icon'>
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </div>

        <div class = 'explain-message'>
          Unfortunately, we can't find that request.
        </div>
        <div class = 'explain-message'>
          <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
        </div>

        <div class = 'button-wrapper'>

        </div>
      </div>      


    </div>

  </v-container>
</template>

<script>
import axios from 'axios';
import api from '@/api.js';
import logo from '@/assets/logo.webp';
import { parse, format } from 'date-fns';

export default {
  name: 'VacantRequestView',
  components: { 
  },    
  data() {
      return {
          logo,
          isLoaded: false,
          code: null,
          updateUnderway: false,

          isThankYouMode: false, 
          thankYouType: null,

          isRejectConfirmationMode: false,
          rejectReason: '',

          vacant_request: null,
          vacant_request_treatments_indexed: {},
          vacant_request_treatment_schedule_entries_indexed: {},
          vacant_request_jane_patient: null,

          selected_treatment_id: null,

          showErrorAlert: false,
          errorMessage: '',

          selected_schedule_start_date_local_date_nice: null,
          selected_schedule_start_date_string: null,
          selected_hour: null,
          selected_minute: null,
          isAcceptConfirmationMode: false,

          isChevronRightVisible: false,
      } 
  },
  methods: {

    async load() {
      let headers = await api.getApiHeaders();
      try {
        let response = await axios.get(api.getApiUrl('u/vacant-request/search-by-code/' + this.code), { headers });

        this.vacant_request = response.data.vacant_request;
        this.vacant_request_treatments_indexed = {};
        for (let treatment of this.vacant_request.treatments) {
          this.vacant_request_treatments_indexed[treatment.treatment_id] = treatment;
        }
        this.vacant_request_treatment_schedule_entries_indexed = {};
        for (let treatment_schedule_entry of this.vacant_request.treatment_schedule_entries) {
          this.vacant_request_treatment_schedule_entries_indexed[treatment_schedule_entry.treatment_id] = treatment_schedule_entry;
        }
        this.vacant_request_jane_patient = response.data.vacant_request_jane_patient;

        this.selected_treatment_id = null;

        if(this.vacant_request.treatments.length == 1) {
          this.selected_treatment_id = this.vacant_request.treatments[0].treatment_id;
        }
        this.selected_schedule_start_date_local_date_nice = null;
        this.selected_schedule_start_date_string = null;
        this.selected_hour = null;
        this.selected_minute = null;


      } catch (error) {
        console.error('Error:', error);
        if (error.response && error.response.data.detail) {
          this.errorMessage = error.response.data.detail;
        } else {
          this.errorMessage = 'Unable to get request.';
        }
        this.showErrorAlert = true;
      }          
    },

    async loadRefresh() {
      await this.load();
      this.isLoaded = true;
    },

    setConfirm() {
      if(this.selected_hour === null || this.selected_minute === null) {
        this.errorMessage = 'Please select a time.';
        this.showErrorAlert = true;
        return;
      }
      this.isAcceptConfirmationMode = true;
    },
    
    async setAccepted() {
      // /u/vacant-request/search-by-code/{code}/accept
      try {
        let headers = await api.getApiHeaders();
        this.updateUnderway = true;
        await axios.put(api.getApiUrl('u/vacant-request/search-by-code/' + this.code + '/accept'), {
          'local_hour': this.selected_hour,
          'local_minute': this.selected_minute,
          'local_date_string': this.selected_schedule_start_date_string,
          'treatment_id': this.selected_treatment_id
          
        }, { headers });
        this.updateUnderway = false;
        this.isThankYouMode = true;
        this.thankYouType = 'accept';
      } catch (error) {
        console.error('Error:', error);
        this.errorMessage = 'Sorry, an error occurred while accepting the request.';
        this.showErrorAlert = true;
      }
    },

    confirmRejected() {
      this.isRejectConfirmationMode = true;
    },

    async setRejected() {
      // /u/vacant-request/search-by-code/{code}/reject
      try {
        let headers = await api.getApiHeaders();
        this.updateUnderway = true;
        await axios.put(api.getApiUrl('u/vacant-request/search-by-code/' + this.code + '/reject'), {
          rejectReason: this.rejectReason
        }, { headers });
        this.updateUnderway = false;
        this.isRejectConfirmationMode = false;
        this.isThankYouMode = true;
        this.thankYouType = 'reject';
      } catch (error) {
        console.error('Error:', error);
        this.errorMessage = 'Sorry, an error occurred while rejecting the request.';
        this.showErrorAlert = true;
      }

    },
    formatAllowedHourAndMinute(option) {
      let hour = option.hour;
      let minute = option.minute;
      let ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12; // Convert to 12-hour format
      minute = minute < 10 ? '0' + minute : minute; // Add leading zero if needed
      return `${hour}:${minute} ${ampm}`;
    },
    toggleSelectedOption(schedule_entry, option) {

      if (this.selected_schedule_start_date_local_date_nice == schedule_entry.schedule_start_date_local_date_nice && this.selected_hour === option.hour && this.selected_minute === option.minute) {

        this.selected_schedule_start_date_local_date_nice = null;
        this.selected_schedule_start_date_string = null;
        this.selected_hour = null;
        this.selected_minute = null;
      } else {
        this.selected_schedule_start_date_local_date_nice = schedule_entry.schedule_start_date_local_date_nice;
        this.selected_schedule_start_date_string = format(parse(schedule_entry.schedule_start_date__formatted, 'yyyy-MM-dd hh:mm a', new Date()), "yyyy-MM-dd");
        this.selected_hour = option.hour;
        this.selected_minute = option.minute;
      }
    },
    updateShowChevronRight() {
      this.isChevronRightVisible = this.$refs.optionTimes && (this.$refs.optionTimes.scrollLeft + this.$refs.optionTimes.clientWidth < this.$refs.optionTimes.scrollWidth);
    }

  },
  computed: {
    availableDateTimeRanges() {
      if (!this.vacant_request || !this.vacant_request_treatment_schedule_entries_indexed) {
        return [];
      }

      // Collect all unique date/time ranges across all treatments
      const dateRangesMap = new Map();

      for (let treatment of this.vacant_request.treatments) {
        const scheduleData = this.vacant_request_treatment_schedule_entries_indexed[treatment.treatment_id];
        if (scheduleData && scheduleData.schedule_entries) {
          for (let schedule_entry of scheduleData.schedule_entries) {
            const dateKey = schedule_entry.schedule_start_date_local_date_nice;
            
            if (schedule_entry.allowed_hours_and_minutes && schedule_entry.allowed_hours_and_minutes.length > 0) {
              const times = schedule_entry.allowed_hours_and_minutes;
              const minTime = times.reduce((min, t) => 
                (t.hour * 60 + t.minute < min.hour * 60 + min.minute) ? t : min
              );
              const maxTime = times.reduce((max, t) => 
                (t.hour * 60 + t.minute > max.hour * 60 + max.minute) ? t : max
              );

              if (!dateRangesMap.has(dateKey)) {
                dateRangesMap.set(dateKey, {
                  date: dateKey,
                  minTime: minTime,
                  maxTime: maxTime
                });
              } else {
                // Update min/max if needed
                const existing = dateRangesMap.get(dateKey);
                const existingMinMinutes = existing.minTime.hour * 60 + existing.minTime.minute;
                const existingMaxMinutes = existing.maxTime.hour * 60 + existing.maxTime.minute;
                const newMinMinutes = minTime.hour * 60 + minTime.minute;
                const newMaxMinutes = maxTime.hour * 60 + maxTime.minute;

                if (newMinMinutes < existingMinMinutes) {
                  existing.minTime = minTime;
                }
                if (newMaxMinutes > existingMaxMinutes) {
                  existing.maxTime = maxTime;
                }
              }
            }
          }
        }
      }

      // Format the ranges
      return Array.from(dateRangesMap.values()).map(range => {
        const startTime = this.formatAllowedHourAndMinute(range.minTime);
        const endTime = this.formatAllowedHourAndMinute(range.maxTime);
        return `${range.date} ${startTime} - ${endTime}`;
      });
    }
  },
  watch: {
    selected_treatment_id() {
        this.schedule_start_date_local_date_nice = null;
        this.selected_hour = null;
        this.selected_minute = null;
        this.selected_schedule_start_date_local_date_nice = null;
        this.selected_schedule_start_date_string = null;
      }
  },

  async mounted() {
      let split_by_slash = this.$route.path.split("/");
      this.code = split_by_slash[split_by_slash.length - 1];
      await this.loadRefresh();
      this.chevronInterval = setInterval(() => {
        this.updateShowChevronRight();
      }, 100);
  }
    
};
</script>
<style lang="scss" scoped>

$primaryDark: #32598C;
$primaryLight: #00B0DA;
$accent: #F25631;
$error: #FF4B55;
$warningOrange: #F26531;

DIV.status-wrapper {
  > DIV.content-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height:auto;
  }
}

DIV.explain-icon {
  margin-top: 20px;
  text-align: center;
  font-size: 45px;
  color: $accent;
}

DIV.explain-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: $primaryDark;
  margin-top: 20px;
}

DIV.explain-message {
  font-size: 15px;
  font-weight: 500;
  color: $primaryDark;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: 250px;
  text-align: center;
}

DIV.confirm-details {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 9px;
  font-size: 16px;

  > DIV > DIV {
    display: flex;
    align-items: center;
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
    > DIV {
      margin-right: 10px;
      color: $accent;
      display: flex;
      align-items: center;
    }
    > DIV:last-child {
      font-weight: 600;
      color: $primaryDark;
    }
  }
}

.button-wrapper BUTTON.v-btn--variant-outlined {
  &.decline-button {
    color: #FFF;
    border: 1px solid $warningOrange;
    background-color: $warningOrange !important;
    &:hover {
      background-color: darken($warningOrange, 5%) !important;
      border: 1px solid darken($warningOrange, 5%);
      color: #FFF;
    }
  }
}

DIV.option-selection-times {
  margin-bottom:10px;
  white-space: auto;

  .option-date-title {
    margin-top:0.5rem;
  }

  @media (max-width: 630px) {     
    overflow-x: auto; 
    overflow-y: hidden;
    white-space: nowrap; 
    width:100%;
    -ms-overflow-style: none; 
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }   
   
  }


  > DIV > BUTTON {
    margin-right: 10px;
    margin-top: 10px;
    border: 1px solid #00000033;
    border-radius: 9px;
    font-weight:500;
    padding-left:10px;
    padding-right:10px;
    &.active {
      background-color: $accent;
      color: white;
      font-weight:600;
      padding-left:9px;
      padding-right:9px;      
    }
    transition: none !important;
  }
}

.option-selection-times-chevron-right {
  margin-top:28px; 
  position: absolute !important;
  right: 10px; 
  transform: translateY(-50%); 
  background: rgba(255,255,255,0.7); 
  border-radius: 50%; 
  box-shadow: 0 10px 20px #0001; 
  z-index: 2; 
  backdrop-filter: blur(20px); 
  -webkit-backdrop-filter: blur(20px);
}

</style>
